<!--
 * @Description: 值班表
 * @Author: PF
 * @Date: 2023-09-18 17:13:25
 * @LastEditors: PF
 * @LastEditTime: 2025-05-27 12:01:54
-->
<template>
  <div>
    <el-dialog class="wp65 hp75" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <div>
            <span class="header-title">详情</span>
          </div>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
              <el-form-item>
                <el-select placeholder="值班人" v-model="dataGrid.parms.zbryid" clearable filterable @change="bindTable()">
                  <el-option v-for="item in zbryData" :key="item.zbryid" :label="item.zbryxm" :value="item.zbryid"/>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-tabs v-model="activeName" >
                  <el-tab-pane label="值班内容" name="lb"></el-tab-pane>
                  <el-tab-pane label="值班制度" name="zd"></el-tab-pane>
                </el-tabs>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
              <ul>
                <li><span class="title">值班类别：</span>{{ info.zblbmc }}</li>
                <li><span class="title">值班内容：</span>{{ info.zbnrmc }}</li>
                <li><span class="title">值班位置：</span>{{ info.zbwz }}</li>
                <li><span class="title">值班时段：</span><span v-for="(item, index) in zbsdData" :key="index"><span v-if="info.zbsd === item.value">{{item.name}}</span></span></li>
                <li><span class="title">值班时间：</span>{{ info.zbkssj }}<span v-if="info.zbkssj && info.zbjssj">-</span>{{ info.zbjssj }}</li>
              </ul>
          </el-header>
          <el-main>
            <el-table v-if="activeName === 'lb'" :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="值班日期" prop="zbrq" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="值班人（手机）" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span class="mr5">{{ scope.row.zbryxm }}</span>
                  <span>{{ scope.row.yddh }}</span>
                </template>
              </el-table-column>
              <el-table-column label="职务" prop="zwmc" align="center" show-overflow-tooltip />
            </el-table>
            <el-card v-if="activeName === 'zd'" shadow="never"><p style="white-space: pre-wrap; text-indent:0;" v-html="zblbInfo.zbzdnr"></p></el-card>
          </el-main>
        </el-container>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { actionPost, loadSelect, homeCloseWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 加载 值班类别 下拉框
const zblbData = ref([])
loadSelect({ url: '/api/v2/bangong/zhibanleibie/list', data: zblbData, order: 'sx', sort: 'asc' })
// 加载 值班内容 下拉框
const zbnrData = ref([])
loadSelect({ url: '/api/v2/bangong/zhibanneirong/list', data: zbnrData, parms: { zt: 2 }, order: 'zbnrmc', sort: 'asc' })
// 加载 值班时段 下拉框
const zbsdData = ref([])
loadSelect({ url: '/api/v2/bangong/zhibanneirong/zhibanshiduan', data: zbsdData })

const activeName = ref('lb')

const dataGrid = ref({
  parms: {},
  data: [],
  loading: false,
  orderBy: { prop: 'zbrq', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  }
})
const bindTable = async () => {
  dataGrid.value.parms.order = 'zbrq'
  dataGrid.value.parms.sort = 'asc'
  dataGrid.value.parms.zblbid = dataGrid.value.parms.zblbid || undefined
  dataGrid.value.parms.zbnrid = dataGrid.value.parms.zbnrid || undefined
  dataGrid.value.parms.bzrxm = dataGrid.value.parms.bzrxm || undefined
  const o = { url: '/api/v2/bangong/zhibanrenyuanjilu/list', data: dataGrid.value.parms }
  dataGrid.value.loading = true // 开始加载
  actionPost(o).then((res) => {
    dataGrid.value.loading = false // 结束加载
    if (res.code === 200) {
      dataGrid.value.data = res.data || [] // 返回列表
      info.value = res.data.length ? res.data[0] : {}
    } else {
      warningPrompt(res.message)
    }
  })
}

// 弹窗
const openList = ref(false)

const zbryData = ref([])
const zblbInfo = ref({})
const info = ref({})

watch(
  () => props.open,
  () => {
    if (props.open === 'zhibanbiao') {
      openList.value = true
      dataGrid.value.parms.zbrwid = props.row.id
      loadSelect({ url: '/api/v2/bangong/zhibanneirongrenyuan/list', data: zbryData, parms: { zbnrid: props.row.zbnrid }, order: 'zbrygh', sort: 'asc' })
      loadSelect({ url: '/api/v2/bangong/zhibanleibie/' + props.row.zblbid, data: zblbInfo })
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

</script>
<style lang="less" scoped>
ul {
  display: flex;
  flex-wrap: wrap;
  li {
    margin-right: 15px;
    margin-bottom: 5px;
    .title {
      color: #000;
    }
  }
}
:deep(.el-tabs__header) {
  margin-bottom: 0px;
}
:deep(.el-card) {
  height: 100%;
}
:deep(.el-card__body) {
  height: 100%;
  overflow: auto;
}
:deep(.search-box){
 justify-content: space-between !important;
}

</style>
